var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1178,
    height: 579,
    viewBox: "0 0 1178 579",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22 0 0 1.12 589.35 291.27)",
    id: "eELliZ-ue8H_SRpAg8oZ-"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.44 0 0 1.44 0 0)",
    id: "3lKCV_NDh49rhlSDD8rw-"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(179,179,179)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,242,209)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -315.65853 133.57788 C -298.57705 92.82861 -261.33239 64.0585 -217.5899 57.823539999999994 L -196.95389 54.88213 L -196.95389 54.88213 C -167.02792 50.63395 -139.85025000000002 35.12809 -120.96534 11.527849999999994 L -68.29227 -53.89007 L -68.29227 -53.89007 C -41.35174000000001 -87.33664 -0.7216700000000031 -106.79399000000001 42.22556 -106.81601 L 142.89311 -106.81601 L 142.89311 -106.81601 C 164.03221000000002 -106.81601 184.53625 -114.04176000000001 201.00484 -127.29494 L 211.17072 -135.47598 L 211.17072 -135.47598 C 237.07817 -156.32513 268.24432 -169.60764999999998 301.22661 -173.85636 L 334.3302 -178.1207 L 333.84587999999997 178.12074 L -334.33022000000005 178.12074 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07 0 0 0.94 122.58 89.58)",
    id: "zoSA2NDyEvg7km3k5CM4p"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(179,179,179)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,251,245)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -318.59552 140.58433 C -299.59977000000003 95.26840999999999 -261.79310000000004 64.12416999999999 -218.24346000000003 57.91669999999999 L -194.92652000000004 54.593149999999994 L -194.92652000000004 54.593149999999994 C -166.21007000000003 50.49996999999999 -139.69008000000002 34.878879999999995 -120.07816000000004 10.505179999999996 L -69.25006000000005 -52.663990000000005 L -69.25006000000005 -52.663990000000005 C -41.476860000000045 -87.18053 -2.365020000000044 -106.81602000000001 38.615099999999956 -106.81602000000001 L 145.39606999999995 -106.81602000000001 L 145.39606999999995 -106.81602000000001 C 165.02479999999994 -106.81602000000001 184.17570999999995 -113.75163 200.23684999999995 -126.67691 L 212.12562999999994 -136.24446 L 212.12562999999994 -136.24446 C 237.49357999999995 -156.65945 266.93620999999996 -169.43915 297.74483999999995 -173.40786 L 334.33020999999997 -178.12072 L 333.84588999999994 178.12072 L -334.3302100000001 178.12072 z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatches);
export default __webpack_public_path__ + "static/media/matches.4ed4b0b3da2d385f564d8c65090a919d.svg";
export { ForwardRef as ReactComponent };